import { render } from "./ProductAddedToCartPopUpComponent.vue?vue&type=template&id=94b3f4aa&scoped=true"
import script from "./ProductAddedToCartPopUpComponent.vue?vue&type=script&lang=js"
export * from "./ProductAddedToCartPopUpComponent.vue?vue&type=script&lang=js"

import "./ProductAddedToCartPopUpComponent.vue?vue&type=style&index=0&id=94b3f4aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b3f4aa"]])

export default __exports__